<template>
  <div id="landing">
    <header class="main_menu">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <ul style="margin-bottom: 0;padding-left:0;">
              <li style="float: right;">
                <i
                  class="fas fa-globe  dropdown-toggle-split"
                  style="margin-top:10px;"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></i>
                <div
                  class="dropdown-menu bgs"
                  style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;"
                >
                  <a
                    @click="handleChange('en-us')"
                    :style="{ color: eng_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="en"
                  >
                    <flag iso="us" /> English</a
                  >
                  <template v-for="lang in this.lang_list" :key="lang.id">
                    <a
                    @click="handleChange(lang.language)"
                    :style="{ color: lang_select == lang.language ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                   <template v-if="lang.language == 'uk'"> <flag iso="ua" /> {{lang.country}} </template> <template v-else> <flag :iso="lang.language" /> {{lang.country}} </template>
                  </a>
                  </template>
                  <!-- <a
                    @click="handleChange('th')"
                    :style="{ color: thai_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="th" /> ไทย
                  </a>
                  <a
                    @click="handleChange('ja')"
                    :style="{ color: jap_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="jp" /> 日本
                  </a>
                  <a
                    @click="handleChange('ko')"
                    :style="{ color: ko_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="kp" /> 韓国語
                  </a>
                  <a
                    @click="handleChange('it')"
                    :style="{ color: it_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="it" /> italiano</a
                  >
                  <a
                    @click="handleChange('zh-hans')"
                    :style="{ color: ch_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="cn" /> 简体中文</a
                  > -->
                  <!-- <template v-if="this.lang1">
                  <a
                    @click="handleChange('ro')"
                    :style="{ color: ro_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="ro" /> România</a
                  >
                  </template>
                  <template v-if="this.lang2">
                  <a
                    @click="handleChange('uk')"
                    :style="{ color: uk_lang ? 'red' : '#000000' }"
                    class="dropdown-item"
                    data-value="th"
                  >
                    <flag iso="ua" /> Україна</a
                  >
                  </template> -->
                  <!-- <a @click="handleChange('ru')" :style="{color: ru_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="ru" /> русский</a> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <section
      class="blog_item_section"
      style="margin-top:10px; min-height: 65vh;
    height: auto !important;"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <img
              :src="this.logo"
              @error="ResimageLoadError"
              style="display: block; margin-left: auto; margin-right: auto; max-width: 110px; border-radius: 33%;"
            />
            <br />
            <h3 class="text-center" style="font-weight:700">
              {{ restaurant_name }}
            </h3>
            <p class="text-center" style="font-size:17px;">{{ description }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center mt-2">
            <button
              href=""
              data-toggle="modal"
              v-on:click="openModal()"
              class="genric-btn primary circle mb-3"
              style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;"
            >
              {{ $t("message.start", {}, { locale: lang }) }}</button
            >
          </div>
        </div>

        <div class="col-lg-12">
          <div class="form-group" style="font-size: 14px;text-align: center;">
            <input style="    height: 13px !important;" type="checkbox" id="terms" required>  <span>{{ $t("message.iagreetothe", {}, { locale: lang }) }} <a style=" color:red;text-decoration: underline;" href="https://qr4menu.in/mobile_terms_conditions/">{{ $t("message.termsconditions", {}, { locale: lang }) }}</a> {{ $t("message.and", {}, { locale: lang }) }} <a style=" color:red;text-decoration: underline;" href="https://qr4menu.in/mobile_privacy_policy/">{{ $t("message.privacypolicy", {}, { locale: lang }) }}</a></span>                 
        </div>
        </div>

        <div
          class="modal fade"
          id="static-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  {{ temp_page_name }}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {{ temp_page_content }}
              </div>
              <div class="modal-footer"></div>
            </div>
          </div>
        </div>

        <div
          style="background-repeat: no-repeat; background-size: cover;"
          class="modal fade"
          id="partner_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content"
              style="border-radius: 15px;margin: 0 15px;"
            >
              <div class="modal-body">
                <p
                  class="text-center"
                  style="font-size: 18px; color: #000;font-weight: 600;"
                >
                  {{ $t("message.joinorder", {}, { locale: lang }) }}
                </p>
                <div class="form-group">
                  <input style="text-align: left;"
                    class="form-control"
                    type="number"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="6"
                    id="txtPassportNumber"
                    :placeholder="$t('message.enterpin', {}, { locale: lang })"
                    v-on:keyup="removeDisabled()"
                  />
                  <input
                    id="btnSubmit"
                    type="button"
                    :value="$t('message.join', {}, { locale: lang })"
                    disabled="disabled"
                    v-on:click="joinPinSession()"
                    style="background: #fff;
    border: none;
    position: absolute;
    right: 25px;
    bottom: 46px;
    width: auto;"
                  />
                </div>
                <!-- <p
                  class="text-center"
                  style="font-size: 13px;margin-top: 5px; color: #000;font-weight: 600;margin-bottom:4px;"
                >
                  {{ $t("message.or", {}, { locale: lang }) }}
                </p> -->
  
                <!-- <p class="text-center mt-1">
                  <a
                    :href="
                      '/menu/' + restaurant_id + '/' + table_id
                    "
                    class="genric-btn primary circle mb-2"
                    style="font-size:15px;box-shadow: 2px 2px 7px #a7a7a7;"
                    data-toggle="modal"
                    data-target="#exampleModalCenter"
                    v-on:click="joinStartSession()"
                    >{{ $t("message.startnew", {}, { locale: lang }) }}</a
                  >
                </p> -->
              </div>
            </div>
          </div>
        </div>

        <div
          style="background-repeat: no-repeat; background-size: cover;"
          class="modal fade"
          id="partner_modal1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content"
              style="border-radius: 15px;margin: 0 15px;"
            >
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-4 offset-md-4 mt-4">
                    <div class="form-group">
                      <input
                        style="max-width: 70%;margin: 0 auto;height: 33px;"
                        maxlength="20"
                        class="form-control"
                        name="subject"
                        id="nick_name1"
                        type="text"
                        placeholder="Enter Your Name"
                      />
                    </div>
                  </div>
                </div>
                <p class="text-center mt-1">
                  <button
                    type="button"
                    class="genric-btn primary circle mb-2"
                    style="font-size:15px;box-shadow: 2px 2px 7px #a7a7a7;"
                    v-on:click="submitSessionone()"
                  >
                    {{ $t("message.startnew", {}, { locale: lang }) }}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </section>

    <footer class="footer-area">
      <div class="container">
        <div class="row">
          <div class="col-xl-12 col-sm-12 col-md-12 col-lg-12">
            <div
              class="single-footer-widget footer_2"
              style="text-align: center;"
            >
              <h4>{{ $t("message.intouch", {}, { locale: lang }) }}</h4>
              <div class="contact_info">
                <p>
                  <span>
                    {{ $t("message.address", {}, { locale: lang }) }}: </span
                  >{{ address }}
                </p>
                <p>
                  <span> {{ $t("message.phone", {}, { locale: lang }) }}: </span
                  >{{ phone_number }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="copyright_part_text"
          style="margin-top:0px; padding-top:10px !important;"
        >
          <div class="row">
            <div class="col-lg-12" style="text-align: center;">
              <a
                style="color:#ff6426"
                v-for="static_page in static_pages"
                :key="static_page.id"
                v-on:click="openStaticModal(static_page.id)"
              >
                {{ static_page.page_name }} |
              </a>
              <p class="footer-text m-0">
                {{ $t("message.copyright", {}, { locale: lang }) }} &copy;
                {{ $t("message.allrights", {}, { locale: lang }) }}
              </p>
            </div>
            <div class="col-lg-12" style="text-align: center;">
              <div class="copyright_social_icon text-right">
                <template v-if="this.facebook">
                <a :href="facebook" target="_blank"
                  ><i class="fab fa-facebook-f"></i
                ></a>
                </template>
                <template v-if="this.twitter">
                <a :href="twitter" target="_blank"
                  ><i class="fab fa-twitter"></i
                ></a>
                </template>
                <template v-if="this.youtube">
                <a :href="youtube" target="_blank"
                  ><i class="fab fa-youtube"></i
                ></a>
                </template>
                <template v-if="this.instagram">
                <a :href="instagram" target="_blank"
                  ><i class="fab fa-instagram"></i
                ></a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import "@meforma/vue-toaster";
export default {
  name: "Landing",
  
  data: function() {
    return {
      lang: "en-us",
      restaurant_id: null,
      table_id: null,
      restaurant_name: null,
      phone_number: null,
      description: null,
      address: null,
      logo: null,
      currency: null,
      sessions: [],
      eng_lang: false,
      thai_lang: false,
      jap_lang: false,
      ko_lang: false,
      it_lang: false,
      ch_lang: false,
      ru_lang: false,
      uk_lang: false,
      facebook: "",
      youtube: "",
      twitter: "",
      instagram: "",
      static_pages: [],
      temp_page_content: null,
      temp_page_name: null,
      is_pin_enable: "",
      session_id: "",
      base_url: '',
      table_list: '',
      direct_order:'',
      lang1: false,
      lang2: false,
      lang_list: [],
      lang_select: ''
    };
  },
  methods: {
    openStaticModal: function(page_id) {
      this.$router.push("/static" + page_id);
    },
    openModal: function() {

      var session_id = localStorage.getItem("session_id");
      
      if (session_id) {

        if(!navigator.onLine){
        this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })

            return false;
      }

        if(this.jQuery('#terms').is(':checked')){  
        this.jQuery("#partner_modal").modal("hide");
        this.$router.push(
          "/menu/" + this.restaurant_id + "/" + this.table_id
        );
        }
        else{
          this.$toast.error(
              this.$t("message.acceptterms", {}, { locale: this.lang }),
              {
                position: "bottom",
                duration: 2000,
              }
            );
        }
      }
      // else if (this.is_pin_enable) {
      //   this.jQuery("#partner_modal").modal("show");
      // } 
      else {
        this.joinStartSession();
      }
    },
    joinStartSession: function() {


     

      if(this.restaurant_id == 1){

          var data5 = new this.formdata();
          data5.append("restaurant_table", this.table_id);
          data5.append("restaurant", this.restaurant_id);

        var config5 = {
      method: "post",
      data:data5,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/create/session/pin/",
      headers: {},
    };
    this.axios(config5).then((response) => {

        console.log("created pin", response.data.data)

        if(response.data.data){

            localStorage.setItem("pin", response.data.data.session_pin);
            localStorage.setItem("session_id", response.data.data.session_uuid);
            localStorage.setItem("order_id", response.data.data.order_id);
            this.$router.push(
              "/menu/" + this.restaurant_id + "/" + this.table_id
            );
            event.preventDefault();
        }
        
    });
      }

      else{

        var acceptTerms = this.jQuery('#terms').is(':checked');
        // alert(acceptTerms);

      var data1 = new this.formdata();
      data1.append("restaurant_table", this.table_id);
      data1.append("restaurant", this.restaurant_id);

      if(!navigator.onLine){
        this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })

            return false;
      }
      
      else{


        if(acceptTerms){
        var config2 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/check/session_is_exist/" +
          this.table_id +
        "/",
      headers: {},
    };
    this.axios(config2).then((response) => {

      console.log("ressssssssss", response);

        if(!response.data.data){
            var config3 = {
      method: "post",
      data:data1,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/create/session/pin/",
      headers: {},
    };
    this.axios(config3).then((response) => {

        console.log("created pin", response.data.data)

        if(response.data.data){

            localStorage.setItem("pin", response.data.data.session_pin);
            localStorage.setItem("session_id", response.data.data.session_uuid);
            localStorage.setItem("order_id", response.data.data.order_id);
            this.$router.push(
              "/menu/" + this.restaurant_id + "/" + this.table_id
            );
            event.preventDefault();
        }
        
    });
        }
        else{
          // alert(acceptTerms)
          this.jQuery("#partner_modal").modal("show");
        }
    });
      }
      else{

        this.$toast.error(
              this.$t("message.acceptterms", {}, { locale: this.lang }),
              {
                position: "bottom",
                duration: 2000,
              }
            );
        // alert("checked");
      }
      }
      }
    },
    removeDisabled: function() {
      console.log("test");
      //Reference the Button.
      event.preventDefault();
      if (this.jQuery("#txtPassportNumber").val() != "") {
        this.jQuery("#btnSubmit").prop("disabled", false);
      } else {
        this.jQuery("#btnSubmit").prop("disabled", true);
      }
    },
    joinPinSession: function() {
      this.jQuery("#partner_modal").modal("hide");
      var data = new this.formdata();
      data.append("session_pin", this.jQuery("#txtPassportNumber").val());
      var configSession = {
        method: "post",
        data: data,
        url:
          process.env.VUE_APP_BASE_URI +
          "/api/userapi/restaurant/get/uuid/pin/",
        headers: {},
      };
      this.axios(configSession).then((response) => {
        if (response.status) {
          if (response.data.status == "success") {
            localStorage.setItem("pin", response.data.data.session_pin);
            localStorage.setItem("session_id", response.data.data.session_uuid);
            localStorage.setItem("order_id", response.data.data.order_id);
            this.$router.push(
              "/menu/" + this.restaurant_id + "/" + this.table_id
            );
            event.preventDefault();
          } else {
            this.$toast.error(
              this.$t("message.wrongpin", {}, { locale: this.lang }),
              {
                position: "bottom",
                duration: 2000,
              }
            );
            event.preventDefault();
          }
        }
      });
    },

    ResimageLoadError: function(event) {
      event.target.src = require("@/assets/website/img/logo.png");
    },
    handleChange: function(a) {
      localStorage.setItem("lang", a);
      this.lang = a;
      if (a === "en-us") {
        this.eng_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = ''
      } else if (a === "th") {
        this.thai_lang = true;
        this.eng_lang = false;
        this.jap_lang = false;
        this.ko_lang = false;
        this.it_lang = false;
        this.ch_lang = false;
        this.ro_lang = false;
        this.ru_lang = false;
        this.uk_lang = false;
      } else if (a === "ko") {
        this.ko_lang = true;
        this.thai_lang = false;
        this.jap_lang = false;
        this.eng_lang = false;
        this.it_lang = false;
        this.ch_lang = false;
        this.ro_lang = false;
        this.ru_lang = false;
        this.uk_lang = false;
      } else if (a === "ja") {
        this.jap_lang = true;
        this.thai_lang = false;
        this.eng_lang = false;
        this.ko_lang = false;
        this.it_lang = false;
        this.ch_lang = false;
        this.ro_lang = false;
        this.ru_lang = false;
        this.uk_lang = false;
      } else if (a === "it") {
        this.it_lang = true;
        this.thai_lang = false;
        this.jap_lang = false;
        this.ko_lang = false;
        this.eng_lang = false;
        this.ch_lang = false;
        this.ro_lang = false;
        this.ru_lang = false;
        this.uk_lang = false;
      } else if (a === "zh-hans") {
        this.ch_lang = true;
        this.thai_lang = false;
        this.jap_lang = false;
        this.ko_lang = false;
        this.it_lang = false;
        this.eng_lang = false;
        this.ro_lang = false;
        this.ru_lang = false;
        this.uk_lang = false;
      }
      else if (a === "ro") {

        this.lang_select = a;
        // this.ro_lang = true;
        // this.ch_lang = false;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        this.eng_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
      }
      else if (a === "ru") {
        this.lang_select = a;
        // this.ch_lang = false;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        this.eng_lang = false;
        // this.ro_lang = false;
        // this.uk_lang = false;
      }
      else if (a === "uk") {
        this.lang_select = a;
        // this.ch_lang = false;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        this.eng_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
      }
    },
  },
  mounted: function() {

    this.jQuery("#terms").prop("checked", true);
    
    if (localStorage.getItem("session_id")) {

      var local_table = localStorage.getItem("table_id");

      if(local_table != this.$route.params.table_id){
          
          localStorage.clear();
          location.reload();
      }
      else{
      var session_id = localStorage.getItem('session_id');

      var config1 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/check/session/validation/" +
          this.$route.params.table_id +
          "/" +
          session_id +
        "/",
      headers: {},
    };
    this.axios(config1).then((response) => {
        console.log(response.data.data.status);
        if (!response.data.data.status) {
          localStorage.removeItem("session_id");
          localStorage.setItem("table_id", this.$route.params.table_id);
          localStorage.removeItem("pin");
        }
  
    });
      }
    }
    if(navigator.onLine){
    this.restaurant_id = this.$route.params.restaurant_id;
    this.table_id = this.$route.params.table_id;
    console.log("table:", this.table_id);
    this.$store.state.restaurant_id = this.restaurant_id;
    this.$store.state.table_id = this.table_id;
    localStorage.setItem("restaurant_id", this.restaurant_id);
    localStorage.setItem("table_id", this.table_id);
    localStorage.setItem("lang", "en-us");

    var config = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/landing/" +
        this.restaurant_id +
        "/" +
        this.table_id +
        "/",
      headers: {},
    };
    this.axios(config).then((response) => {
      if (response.status) {
        var data = response.data.data;
        localStorage.setItem("restaurant_name", data.name);
        if (data.status == false) {
          this.$router.push("/offline/");
        }

        this.is_pin_enable = data.is_pin_enable;

        if (data.restaurant_social_link.length) {
          this.facebook = data.restaurant_social_link[0].facebook;
        } else {
          this.facebook = "";
        }
        if (data.restaurant_social_link.length) {
          this.twitter = data.restaurant_social_link[0].twitter;
        } else {
          this.twitter = "";
        }
        if (data.restaurant_social_link.length) {
          this.youtube = data.restaurant_social_link[0].youtube;
        } else {
          this.youtube = "";
        }
        if (data.restaurant_social_link.length) {
          this.instagram = data.restaurant_social_link[0].instagram;
        } else {
          this.instagram = "";
        }
        this.static_pages = data.restaurant_static_page;
        this.restaurant_name = data.name;
        this.phone_number = data.phone_number;
        this.description = data.description;
        this.address = data.address;
        this.logo = process.env.VUE_APP_BASE_URI + data.logo;
        this.currency = data.currency;
        // this.direct_order = data.is_direct_order_table;
        localStorage.setItem("currency", this.currency);
        localStorage.setItem("logo", this.logo);
        localStorage.setItem("direct_order", data.is_direct_order_table);
      }
    });


    var config5 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/language/list/" +
        this.restaurant_id +
        "/",
      headers: {},
    };
    this.axios(config5).then((response) => {
      if (response.status) {

          this.lang_list = response.data.data;          
      }
    });
    }
  else{
    this.$toast.error(this.$t("message.no_internet", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            
  }
  },
  

};
</script>

<style>
a:hover {
  text-decoration: none !important;
}
.frame {
  overflow-y: auto;
  height: 108px;
}
.frame::-webkit-scrollbar {
  width: 3px;
}
.frame::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.frame::-webkit-scrollbar-thumb {
  background: #888;
}
.frame::-webkit-scrollbar-thumb:hover {
  background: #555;
}
#btnsubmit {
  color: #ff6426;
  font-weight: 500;
}
</style>